import { render, staticRenderFns } from "./ModalRemovedFreePicks.vue?vue&type=template&id=8220529c&scoped=true"
import script from "./ModalRemovedFreePicks.vue?vue&type=script&lang=js"
export * from "./ModalRemovedFreePicks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8220529c",
  null
  
)

export default component.exports